import MasonryWall from "@yeger/vue-masonry-wall";
const masonry = {
  install: async (app) => {
    if (typeof process === "undefined" || process.client) {
      app.use(MasonryWall);
    }
  }
};
export {
  masonry as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFzb25yeS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BsdWdpbnMvYmFuemEvbWFzb25yeS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTWFzb25yeVdhbGwgZnJvbSAnQHllZ2VyL3Z1ZS1tYXNvbnJ5LXdhbGwnXG5cbmV4cG9ydCBkZWZhdWx0IHtcbiAgaW5zdGFsbDogYXN5bmMgKGFwcCkgPT4ge1xuICAgIGlmICh0eXBlb2YgcHJvY2VzcyA9PT0gXCJ1bmRlZmluZWRcIiB8fCBwcm9jZXNzLmNsaWVudCkge1xuICAgICAgYXBwLnVzZShNYXNvbnJ5V2FsbCk7XG4gICAgfVxuICB9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRUEsTUFBZSxVQUFBO0FBQUEsRUFDYixTQUFTLE9BQU8sUUFBUTtBQUN0QixRQUFJLE9BQU8sWUFBWSxlQUFlLFFBQVEsUUFBUTtBQUNwRCxVQUFJLElBQUksV0FBVztBQUFBLElBQ3pCO0FBQUEsRUFDRztBQUNIOyJ9
